import React from 'react';
import { Tag } from 'lucide-react';

interface TagProps {
  tags: {
    id: number;
    name: string;
    slug: string;
  }[];
  onTagClick?: (tag: string) => void;
  className?: string;
}

const TagList: React.FC<TagProps> = ({ tags, onTagClick, className = '' }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      <Tag className="w-4 h-4 text-gray-500 mt-1" />
      {tags.map((tag) => (
        <button
          key={tag.id}
          onClick={() => onTagClick && onTagClick(tag.name)}
          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
        >
          {tag.name}
        </button>
      ))}
    </div>
  );
};

export default TagList;